import * as React from 'react';
import { createRoot } from 'react-dom/client';
import {
  RootContext,
  AbstractForm,
  MnInputText,
  MnInputFile,
  MnInputRadioGroup,
  MnInputSelect,
  MnButton,
  MnInputReservation,
  MnInputCheckboxGroup,
  TelValidatorJa,
  TelValidatorNotJa,
  PostalCodeValidatorJa,
  PostalCodeValidatorNotJa,
  MnInputDate,
  PatientValidators,
  TreatmentValidators,
  MnInlineMessage,
  PatientsSexes,
  TreatmentsHasReferrals,
  KanaValidator,
  TreatmentUserApiV1InstitutionMenuPath,
  PostalCodeUserApiV1TreatmentsPath,
  UserApiV1StripeClientSecretResetPath,
  UserApiV1InstitutionUploadFilesPath,
  UserApiV1TreatmentsPath,
  TermsInstitutionsPath,
  RegionalMedicalCooperationTermsPath,
  MnDialog,
} from '../../../index';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CardSetupForm from '../molecules/CardSetupForm';
import moment from 'moment';
import { PatientHealthConditionForm, TreatmentReferringInstitutionForm } from './index';

export default class TreatmentsNew extends AbstractForm {
  static contextType = RootContext;

  PatientsSexes = PatientsSexes.filter(sex => sex.key !== 'not_known');
  TreatmentsHasReferrals = TreatmentsHasReferrals.reverse();

  constructor (props) {
    super(props);
    this.state = {
      ...props,
      isSaved: false, // 保存チェック
      isCardRegistered: false, // クレジットカード登録チェック
      annotation: {}, // エラー表示
    };

    this.files = {
      insurance_cards: React.createRef(),
      etc_images: React.createRef(),
      patient_registration_images: React.createRef(),
      documents_related_to_referral_letter: React.createRef(),
    };

    this.onChangePatient = this.onChangePatient.bind(this);
    this.onChangeTreatment = this.onChangeTreatment.bind(this);
    this.onChangeReferringInstitution = this.onChangeReferringInstitution.bind(this);
    this.onChangePatientHealthCondition = this.onChangePatientHealthCondition.bind(this);
    this.onChangeRequestedDate = this.onChangeRequestedDate.bind(this);
    this.onSetAddress = this.onSetAddress.bind(this);
    this.onChangeBirthday = this.onChangeBirthday.bind(this);
    this.onChangeFiles = this.onChangeFiles.bind(this);
    this.onRegisterCard = this.onRegisterCard.bind(this);
    this.onUnregisterCard = this.onUnregisterCard.bind(this);
    this.onRequestDateValidation = this.onRequestDateValidation.bind(this);
    this.onCardValidation = this.onCardValidation.bind(this);
    this.getPeriodValidator = this.getPeriodValidator.bind(this);

    this.onValidate({ name: 'requested_date', validate: this.onRequestDateValidation, run: false });
    this.onValidate({ name: 'credit_card', validate: this.onCardValidation, run: false });
  }

  componentDidMount () {
    const ids = location.pathname.split('/').filter(s => s !== '').slice(-5);
    const referringInstitutionForm = JSON.parse(localStorage.getItem('referring_institution'));
    this.context.showLoading();
    this.context.fetch(TreatmentUserApiV1InstitutionMenuPath(ids[0], ids[2])).then(body => {
      this.setState({ treatment: { ...body.result, referring_institution: referringInstitutionForm ?? {} }, menu: body.result.menu });
    }).finally(() => {
      this.context.hideLoading();
    });
    // 問診が保存されないまま遷移する場合はすべてのファイルを削除
    window.addEventListener('beforeunload', () => {
      if (!this.state.isSaved) {
        this.files.insurance_cards.current.deleteAll();
        this.files.etc_images.current.deleteAll();
        this.files.patient_registration_images.current.deleteAll();
        this.files.documents_related_to_referral_letter.current.deleteAll();
      }
    });
  }

  onSetAddress () {
    this.fetch(`${PostalCodeUserApiV1TreatmentsPath()}?code=${this.state.treatment.patient.postal_code}`).then(data => {
      const treatment = this.state.treatment;
      treatment.patient.prefecture_code = `00${data.result.prefecture_code}`.slice(-2);
      treatment.patient.address = `${data.result.city}${data.result.town}`;
      this.setState({ treatment: treatment });
    });
  }

  onChangeBirthday (e) {
    const treatment = this.state.treatment;
    treatment.patient.birthday = Object.values(e.value);
    this.setState({ treatment: treatment });
  }

  onChangePatient (e) {
    const treatment = this.state.treatment;
    treatment.patient[e.name] = e.value;
    this.setState({ treatment: treatment });
  }

  onChangePatientHealthCondition (e) {
    const treatment = this.state.treatment;
    treatment.patient.patient_health_condition[e.name] = e.value;
    this.setState({ treatment: treatment });
  }

  onChangeReferringInstitution (e) {
    const treatment = this.state.treatment;
    treatment.referring_institution[e.name] = e.value;
    this.setState({ treatment: treatment });
  }

  onChangeTreatment (e) {
    const treatment = this.state.treatment;
    treatment[e.name] = e.value;
    this.setState({ treatment: treatment });
  }

  onChangeRequestedDate (e) {
    this.onChangeTreatment(e);
    this.onRequestDateValidation().then(() => {
      this.setState({ annotation: { ...this.state.annotation, requested_date: undefined } });
    }).catch(err => {
      this.setState({ annotation: { ...this.state.annotation, requested_date: err } });
    });
  }

  onChangeFiles (e) {
    const images = this.state.treatment.patient.patient_images.filter(file => {
      switch (e.name) {
      case 'insurance_cards':
        return file.image_type !== 'insurance_card';
      case 'etc_images':
        return file.image_type !== 'etc_card';
      case 'patient_registration_images':
        return file.image_type !== 'patient_registration_card';
      case 'documents_related_to_referral_letter':
        return file.image_type !== 'document_related_to_referral_letter';
      }
    });
    e.files.map(file => {
      let imageType = '';
      switch (e.name) {
      case 'insurance_cards':
        imageType = 'insurance_card';
        break;
      case 'etc_images':
        imageType = 'etc_card';
        break;
      case 'patient_registration_images':
        imageType = 'patient_registration_card';
        break;
      case 'documents_related_to_referral_letter':
        imageType = 'document_related_to_referral_letter';
        break;
      }
      images.push({
        code: file.info.code,
        image_type: imageType,
      });
    });
    const treatment = this.state.treatment;
    treatment.patient.patient_images = images;
    this.setState({ treatment: treatment });
  }

  onRegisterCard () {
    this.setState({ isCardRegistered: true, annotation: { credit_card: null } });
  }

  onUnregisterCard () {
    this.setState({ isCardRegistered: false });
  }

  onRequestDateValidation () {
    return new Promise((resolve, reject) => {
      if (this.state?.menu?.accept_datetime_request === 'acceptable') {
        if (
          this.state.treatment.requested_date1 === this.state.treatment.requested_date2 ||
          this.state.treatment.requested_date1 === this.state.treatment.requested_date3 ||
          this.state.treatment.requested_date2 === this.state.treatment.requested_date3
        ) {
          const el = document.querySelector('#requested_date');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          const error = ['Treatment.duplicated_date'];
          reject(error);
        }
      }
      resolve();
    });
  }

  onCardValidation () {
    return new Promise((resolve, reject) => {
      const { menu, isCardRegistered } = this.state;
      if (menu.accept_stripe_payment === 'acceptable' && !isCardRegistered) {
        const el = document.querySelector('#requested_date');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        const error = ['Treatment.credit_card_required'];
        reject(error);
      }
      resolve();
    });
  }

  setLocalStorageReferringInstitution () {
    if (this.state.menu.treatment_category !== 'regional_medical_cooperation') return null;

    try {
      return window.localStorage.setItem('referring_institution', JSON.stringify(this.state.treatment.referring_institution));
    } catch (e) {
      return null;
    }
  }

  validation () {
    return new Promise((resolve, reject) => {
      const errors = {};
      const isInsuranceCardLoading = this.state.menu.is_use_insurance_card && this.files.insurance_cards.current.isLoading();
      const isEtcImageLoading = this.state.menu.is_use_etc_card && this.files.etc_images.current.isLoading();
      const isPatientRegistrationImageLoading = this.state.menu.is_use_patient_registration_card && this.files.patient_registration_images.current.isLoading();
      const isUseDocumentRelatedToReferralLetter = this.state.menu.is_use_document_related_to_referral_letter && this.files.documents_related_to_referral_letter.current.isLoading();
      if (isInsuranceCardLoading || isEtcImageLoading || isPatientRegistrationImageLoading || isUseDocumentRelatedToReferralLetter) {
        this.context.onHeaderToast(this.context.t('Treatment.waiting_upload'));
        const el = isInsuranceCardLoading ? document.querySelector('#insurance_cards') : isEtcImageLoading ? document.querySelector('#etc_images') : isPatientRegistrationImageLoading ? document.querySelector('#patient_registration_images') : isUseDocumentRelatedToReferralLetter ? document.querySelector('#documents_related_to_referral_letter') : null;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return reject(errors);
      }
      let count = 0;
      this.validators.map(validate => {
        validate.validate().catch(err => {
          count++;
          if (errors[validate.name]) {
            errors[validate.name] = [...errors[validate.name], ...err];
          } else {
            errors[validate.name] = err;
          }
        }).finally(() => {
          validate.run = true;
          if (this.validators.findIndex(validate => !validate.run) === -1) {
            if (count === 0) {
              resolve();
            } else {
              this.context.onHeaderToast(this.context.t('Treatment.invalid_form'));
              reject(errors);
            }
            this.validators.map(validate => {
              validate.run = false;
            });
          }
        });
      });
    });
  }

  onSuccess (resolve) {
    this.setLocalStorageReferringInstitution();
    this.context.showLoading();
    const treatment = Object.assign({}, this.state.treatment);
    if (!treatment.has_referral) {
      treatment.has_referral = 'has_not';
    }
    this.context.fetch(UserApiV1TreatmentsPath(), {
      methods: 'POST',
      body: {
        treatment: {
          ...treatment,
          patient: {
            ...this.state.treatment.patient,
            'birthday(1i)': this.state.treatment.patient.birthday[0],
            'birthday(2i)': this.state.treatment.patient.birthday[1],
            'birthday(3i)': this.state.treatment.patient.birthday[2],
            language_code: this.context.lang,
          },
          referring_institution: {
            ...this.state.treatment.referring_institution,
            telephone: this.state.treatment.referring_institution.referring_institution_telephone,
          },
        },
      },
    }).then(data => {
      this.setState({ isSaved: true });
      setTimeout(() => {
        location.href = data.result.url_location.complete;
      }, 10);
    }).catch(err => {
      console.log(err);
      if (err.status === 400) {
        err.json().then(body => {
          this.setState({ annotation: body.errors });
        });
      } else if (err.status === 406) {
        this.context.onHeaderToast(this.context.t('Treatment.request_closing'));
      } else if (err.status === 404) {
        const div = document.createElement('div');
        document.body.appendChild(div);
        const root = createRoot(div);
        root.render(<MnDialog
          isOpen={true}
          title={this.context.t('Treatment.api_error_title')}
          btnSubmitLabel="OK"
          btnCloseHidden={true}
          handleSubmit={ () => {
            location.reload();
          } }
        >{this.context.t('Treatment.api_error_message')}</MnDialog>);
      } else {
        throw err;
      }
    }).finally(() => {
      this.context.hideLoading();
      resolve();
    });
  }

  onFailure (resolve, errors) {
    console.log(errors);
    this.setState({ annotation: errors });
    resolve();
  }

  getPeriodDate (now = moment(), period = this.state?.menu?.acceptable_period) {
    const date = now.startOf('day');
    switch (period) {
    case 'before_one_day':
      date.add(1, 'days');
      break;
    case 'before_three_days':
      date.add(3, 'days');
      break;
    case 'before_one_week':
      date.add(7, 'days');
      break;
    case 'before_two_weeks':
      date.add(14, 'days');
      break;
    case 'before_three_weeks':
      date.add(21, 'days');
      break;
    }
    return date;
  }

  getPeriodValidator (now = Date.now(), period = this.state?.menu?.acceptable_period) {
    const date = this.getPeriodDate(moment(now), period);
    return { validate: [{ min: date.endOf('day').unix() * 1000 }], message: `Treatment.${this.state?.menu?.acceptable_period}` };
  }

  renderPlusIcon () {
    return (<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M7 0C6.44772 0 6 0.447716 6 1V6L1 6C0.447715 6 0 6.44772 0 7C0 7.55228 0.447716 8 1 8H6V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13V8L13 8C13.5523 8 14 7.55228 14 7C14 6.44771 13.5523 6 13 6H8V1C8 0.447715 7.55228 0 7 0Z" fill="#27B1DB"/></svg>);
  }

  renderTermsLink () {
    const url = (this.state?.menu?.treatment_category === 'regional_medical_cooperation') ? RegionalMedicalCooperationTermsPath() : TermsInstitutionsPath();
    return (
      <a target="_blank" rel="noreferrer" href={url}>
        {this.context.t('Treatment.terms')}
      </a>
    );
  }

  render () {
    console.log(this.context, this.state);
    const { treatment, menu } = this.state;
    const patient = this.state?.treatment?.patient || { birthday: [] };
    const referringInstitution = this.state?.treatment?.referring_institution || {};
    const patientHealthCondition = this.state?.treatment?.patient?.patient_health_condition || {};
    const isRegionalMedicalCooperation = (this.state?.menu?.treatment_category === 'regional_medical_cooperation');
    const checklists = this.state?.treatment?.checklists || [];
    const stripePromise = this.state?.treatment?.stripe_publishable_key ? loadStripe(this.state?.treatment?.stripe_publishable_key) : undefined;
    const requestDateValidator = {
      isInt: this.getPeriodValidator(),
    };
    const requestDateRange = { start: this.getPeriodDate().add(1, 'days').toDate(), end: null };
    const { t } = this.context;
    const requiredMessage = 'validation.required';

    return (
      <div className="p-container">
        <div className="l-conatiner">
          <h4 className="w90p c-mn-title-2 ta-c">{t('Treatment.application')}</h4>
          { isRegionalMedicalCooperation
            ? <TreatmentReferringInstitutionForm
              onChange={ this.onChangeReferringInstitution }
              annotation={ this.state.annotation }
              referringInstitution={ referringInstitution }
              onValidate={ this.onValidate }
            /> : null
          }
          <div className="p-interview--content mb-lg">
            { isRegionalMedicalCooperation ? <h5 className="fz-xl lh-sm fw-br">{t('Treatment.patient_information')}</h5> : null }
            <div>
              <p>{t('Treatment.patient_name')}<span className="required">{t('Treatment.required')}</span></p>
              <div className="d-fx">
                <MnInputText
                  name="family_name"
                  value={ patient.family_name }
                  placeholder={t('Treatment.last')}
                  onChange={ this.onChangePatient }
                  onValidate={ this.onValidate }
                  validates={ PatientValidators.family_name_i18n }
                  t={t}
                />
                <MnInputText
                  name="given_name"
                  value={ patient.given_name }
                  placeholder={t('Treatment.first')}
                  onChange={ this.onChangePatient }
                  onValidate={ this.onValidate }
                  validates={ PatientValidators.given_name_i18n }
                  t={t}
                />
              </div>
            </div>
            { this.context.lang === 'ja' ? (<div>
              <p>患者氏名（カナ）<span className="required">{t('Treatment.required')}</span></p>
              <div className="d-fx">
                <MnInputText
                  name="family_name_kana"
                  value={ patient.family_name_kana }
                  convertKana={ true }
                  placeholder="セイ"
                  errors={ this.state.annotation.family_name_kana }
                  onChange={ this.onChangePatient }
                  onValidate={ this.onValidate }
                  onDestroy={ this.onRemoveValidate }
                  validates={ { ...PatientValidators.family_name_kana, ...KanaValidator } }
                />
                <MnInputText
                  name="given_name_kana"
                  value={ patient.given_name_kana }
                  convertKana={ true }
                  placeholder="メイ"
                  errors={ this.state.annotation.given_name_kana }
                  onChange={ this.onChangePatient }
                  onValidate={ this.onValidate }
                  onDestroy={ this.onRemoveValidate }
                  validates={ { ...PatientValidators.given_name_kana, ...KanaValidator } }
                />
              </div>
            </div>) : null }
            <div>
              <p>{t('Treatment.birthday')}<span className="required">{t('Treatment.required')}</span></p>
              <div className="d-fx">
                <MnInputDate
                  name="birthday"
                  value={ { year: patient.birthday[0], month: patient.birthday[1], day: patient.birthday[2] } }
                  onChange={ (e) => { this.onChangeBirthday(e); } }
                  required={ requiredMessage }
                  onValidate={ this.onValidate }
                  isFutureDate={ false }
                  t={t}
                />
              </div>
            </div>
            <div>
              <p>{t('Treatment.sex')}<span className="required">{t('Treatment.required')}</span></p>
              <MnInputRadioGroup
                name="sex"
                value={ patient.sex }
                groups={ this.PatientsSexes }
                errors={ this.state.annotation.sex }
                onChange={ this.onChangePatient }
                onValidate={ this.onValidate }
                required={ requiredMessage }
                t={t}
              />
            </div>
            {menu?.is_use_address ? (<React.Fragment>
              <div>
                <p>{t('Treatment.address')}</p>
                {menu?.treatment_category && menu.treatment_category === 'regional_medical_cooperation'
                  ? <div className="annotation">{this.context.formatSimple(t('Treatment.address_annotation_for_regional_medical_cooperation'))}</div>
                  : <div className="annotation">{this.context.formatSimple(t('Treatment.address_annotation'))}</div>
                }
              </div>
              { this.context.lang === 'ja' ? (<React.Fragment>
                <div>
                  <p className="nest">{t('Treatment.postal_code')}<span className="required">{t('Treatment.required')}</span></p>
                  <div className="d-fx">
                    <MnInputText
                      name="postal_code"
                      value={ patient.postal_code }
                      placeholder={t('Treatment.example_postal_code')}
                      errors={ this.state.annotation.postal_code }
                      onValidate={ this.onValidate }
                      validates={ PostalCodeValidatorJa }
                      onChange={ this.onChangePatient }
                      onDestroy={ this.onRemoveValidate }
                      t={t}
                    />
                    {/* <button className="c-mn-btn--third p-interview--content--btn" onClick={ this.onSetAddress }><span>住所の自動入力</span></button> */}
                  </div>
                </div>
                <div>
                  <p className="nest">{t('Treatment.prefectures')}<span className="required">{t('Treatment.required')}</span></p>
                  <div className="d-fx">
                    <MnInputSelect
                      name="prefecture_code"
                      value={ patient.prefecture_code }
                      groups={ patient.prefectures_i18n }
                      placeholder={t('Treatment.prefectures')}
                      errors={ this.state.annotation.prefecture_code }
                      onChange={ this.onChangePatient }
                      onValidate={ this.onValidate }
                      onDestroy={ this.onRemoveValidate }
                      required={ requiredMessage }
                      t={t}
                    />
                  </div>
                </div>
                <div>
                  <p className="nest">{t('Treatment.town_city')}<span className="required">{t('Treatment.required')}</span></p>
                  <MnInputText
                    name="address"
                    value={ patient.address }
                    placeholder={t('Treatment.example_town_city')}
                    errors={ this.state.annotation.address }
                    onValidate={ this.onValidate }
                    validates={ PatientValidators.address_i18n }
                    onChange={ this.onChangePatient }
                    onDestroy={ this.onRemoveValidate }
                    t={t}
                  />
                </div>
              </React.Fragment>) : (<React.Fragment>
                <div>
                  <p className="nest">{t('Treatment.address_line1')}<span className="required">{t('Treatment.required')}</span></p>
                  <MnInputText
                    name="address_line1"
                    value={ patient.address_line1 }
                    placeholder={t('Treatment.example_address_line1')}
                    errors={ this.state.annotation.address_line1 }
                    onValidate={ this.onValidate }
                    validates={ PatientValidators.address_line1_i18n }
                    onChange={ this.onChangePatient }
                    onDestroy={ this.onRemoveValidate }
                    t={t}
                  />
                </div>
                <div>
                  <p className="nest">{t('Treatment.address_line2')}</p>
                  <MnInputText
                    name="address_line2"
                    value={ patient.address_line2 }
                    placeholder={t('Treatment.example_address_line2')}
                    errors={ this.state.annotation.address_line2 }
                    onValidate={ this.onValidate }
                    validates={ PatientValidators.address_line2_i18n }
                    onChange={ this.onChangePatient }
                    onDestroy={ this.onRemoveValidate }
                    t={t}
                  />
                </div>
                <div>
                  <p className="nest">{t('Treatment.town_city')}<span className="required">{t('Treatment.required')}</span></p>
                  <MnInputText
                    name="address"
                    value={ patient.address }
                    placeholder={t('Treatment.example_town_city')}
                    errors={ this.state.annotation.address }
                    onValidate={ this.onValidate }
                    validates={ PatientValidators.address_i18n }
                    onChange={ this.onChangePatient }
                    onDestroy={ this.onRemoveValidate }
                    t={t}
                  />
                </div>
                <div>
                  <p className="nest">{t('Treatment.postal_code')}</p>
                  <div className="d-fx">
                    <MnInputText
                      name="postal_code"
                      value={ patient.postal_code }
                      placeholder={t('Treatment.example_postal_code')}
                      errors={ this.state.annotation.postal_code }
                      onValidate={ this.onValidate }
                      validates={ PostalCodeValidatorNotJa }
                      onChange={ this.onChangePatient }
                      onDestroy={ this.onRemoveValidate }
                      t={t}
                    />
                    {/* <button className="c-mn-btn--third p-interview--content--btn" onClick={ this.onSetAddress }><span>住所の自動入力</span></button> */}
                  </div>
                </div>
                <div>
                  <p className="nest">{t('Treatment.country')}<span className="required">{t('Treatment.required')}</span></p>
                  <MnInputText
                    name="country"
                    value={ patient.country }
                    placeholder={t('Treatment.example_country')}
                    errors={ this.state.annotation.country }
                    onValidate={ this.onValidate }
                    validates={ PatientValidators.country_i18n }
                    onChange={ this.onChangePatient }
                    onDestroy={ this.onRemoveValidate }
                    t={t}
                  />
                </div>
              </React.Fragment>) }
            </React.Fragment>) : null }
            <div>
              <p>{t('Treatment.contact')}</p>
              {menu?.treatment_category && menu.treatment_category === 'regional_medical_cooperation'
                ? <div className="annotation">{this.context.formatSimple(t('Treatment.contact_annotation_for_regional_medical_cooperation'))}</div>
                : <div className="annotation">{this.context.formatSimple(t('Treatment.contact_annotation'))}</div>
              }
            </div>
            <div>
              <p className="nest">{t('Treatment.phone_number')}<span className="required">{t('Treatment.required')}</span></p>
              <MnInputText
                name="telephone"
                value={ patient.telephone }
                placeholder={t('Treatment.example_phone_number')}
                errors={ this.state.annotation.telephone && this.state.annotation.telephone[0].includes('紹介元') ? null : this.state.annotation.telephone }
                onChange={ this.onChangePatient }
                onValidate={ this.onValidate }
                validates={ this.context.lang === 'ja' ? TelValidatorJa : TelValidatorNotJa }
                t={t}
              />
            </div>
            {menu?.treatment_category && menu.treatment_category !== 'regional_medical_cooperation' ? (
              <div>
                <p className="nest">{t('Treatment.e-mail')}<span className="required">{t('Treatment.required')}</span></p>
                <MnInputText
                  name="email_address"
                  value={ patient.email_address }
                  placeholder={t('Treatment.example_e-mail')}
                  errors={ this.state.annotation.email_address }
                  onChange={ this.onChangePatient }
                  onValidate={ this.onValidate }
                  validates={ PatientValidators.email_address_i18n }
                  t={t}
                />
              </div>
            ) : null}
            {menu?.is_use_has_referral ? (<div>
              <p>{t('Treatment.reference')}<span className="required">{t('Treatment.required')}</span></p>
              <MnInputRadioGroup
                name="has_referral"
                value={ treatment.has_referral }
                groups={ this.TreatmentsHasReferrals }
                errors={ this.state.annotation.has_referral }
                onValidate={ this.onValidate }
                required={ requiredMessage }
                onChange={ this.onChangeTreatment }
                t={t}
              />
            </div>) : null }
            {menu?.is_use_insurance_card ? (<div>
              <p>{t('Treatment.insurance_card')}<span className="required">{t('Treatment.required')}</span></p>
              <div className="annotation mb-md">{this.context.formatMarkdown(t('Treatment.insurance_card_annotation'))}</div>
              <MnInputFile
                ref={this.files.insurance_cards}
                name="insurance_cards"
                title="Treatment.insurance_card_upload"
                class="c-mn-btn--third p-interview--content--btn"
                errors={ this.state.annotation.insurance_cards }
                icon={this.renderPlusIcon}
                acceptMime={treatment.mime_types}
                uploadFile={UserApiV1InstitutionUploadFilesPath(menu.institution.code)}
                onChange={this.onChangeFiles}
                onValidate={ this.onValidate }
                required="Treatment.insurance_card_required"
                t={t}
              />
            </div>) : null }
            {menu?.is_use_etc_card ? (<div>
              <p>{t('Treatment.other_medical_certificate')}</p>
              <div className="annotation mb-md">{this.context.formatSimple(t('Treatment.other_medical_certificate_annotation'))}</div>
              <MnInputFile
                ref={this.files.etc_images}
                name="etc_images"
                title="Treatment.other_medical_certificate_upload"
                class="c-mn-btn--third p-interview--content--btn"
                errors={this.state.annotation.etc_images}
                icon={this.renderPlusIcon}
                acceptMime={treatment.mime_types}
                uploadFile={UserApiV1InstitutionUploadFilesPath(menu.institution.code)}
                onChange={this.onChangeFiles}
                onValidate={ this.onValidate }
                t={t}
              />
            </div>) : null }
            {menu?.is_use_patient_registration_card ? (<div>
              <p>{t('Treatment.registration_card')}</p>
              <div className="annotation mb-md">{this.context.formatSimple(t('Treatment.registration_card_annotation'))}</div>
              <MnInputFile
                ref={this.files.patient_registration_images}
                name="patient_registration_images"
                title="Treatment.registration_card_upload"
                class="c-mn-btn--third p-interview--content--btn"
                errors={ this.state.annotation.etc_images }
                icon={this.renderPlusIcon}
                acceptMime={treatment.mime_types}
                uploadFile={UserApiV1InstitutionUploadFilesPath(menu.institution.code)}
                onChange={this.onChangeFiles}
                onValidate={ this.onValidate }
                t={t}
              />
            </div>) : null }
            {menu?.is_use_document_related_to_referral_letter ? (<div>
              <p>{t('Treatment.document_related_to_referral_letter')}</p>
              <div className="annotation mb-md">{this.context.formatSimple(t('Treatment.document_related_to_referral_letter_annotation'))}</div>
              <MnInputFile
                ref={this.files.documents_related_to_referral_letter}
                name="documents_related_to_referral_letter"
                title="Treatment.document_related_to_referral_letter_upload"
                class="c-mn-btn--third p-interview--content--btn"
                errors={ this.state.annotation.documents_related_to_referral_letter }
                icon={this.renderPlusIcon}
                acceptMime={treatment.mime_types}
                uploadFile={UserApiV1InstitutionUploadFilesPath(menu.institution.code)}
                onChange={this.onChangeFiles}
                onValidate={ this.onValidate }
                t={t}
              />
            </div>) : null }
            {menu?.accept_datetime_request === 'acceptable' ? <div id="requested_date">
              <p>{t('Treatment.request_date')}<span className="required">{t('Treatment.required')}</span></p>
              <div className="annotation mb-md">{this.context.formatSimple(t('Treatment.request_date_annotation'))}</div>
              <div className="mt-md"><MnInputReservation
                name="requested_date1"
                title={t('Treatment.first_choice')}
                placeholder={t('Treatment.first_date')}
                errors={ this.state.annotation.requested_date1 }
                accepts={ menu?.accept_datetime_request === 'acceptable' ? menu?.menu_datetime_requests : undefined }
                dateRange={ requestDateRange }
                onChange={ this.onChangeRequestedDate }
                onValidate={ this.onValidate }
                validates={ requestDateValidator }
                required={ requiredMessage }
                t={t}
                slotMinute={menu?.slot_minute}
              /></div>
              <div className="mt-md"><MnInputReservation
                name="requested_date2"
                title={t('Treatment.second_choice')}
                placeholder={t('Treatment.second_date')}
                errors={ this.state.annotation.requested_date2 }
                accepts={ menu?.accept_datetime_request === 'acceptable' ? menu?.menu_datetime_requests : undefined }
                dateRange={ requestDateRange }
                onChange={ this.onChangeRequestedDate }
                onValidate={ this.onValidate }
                validates={ requestDateValidator }
                required={ requiredMessage }
                t={t}
                slotMinute={menu?.slot_minute}
              /></div>
              <div className="mt-md"><MnInputReservation
                name="requested_date3"
                title={t('Treatment.third_choice')}
                placeholder={t('Treatment.third_date')}
                errors={ this.state.annotation.requested_date3 }
                accepts={ menu?.accept_datetime_request === 'acceptable' ? menu?.menu_datetime_requests : undefined }
                dateRange={ requestDateRange }
                onChange={ this.onChangeRequestedDate }
                onValidate={ this.onValidate }
                validates={ requestDateValidator }
                required={ requiredMessage }
                t={t}
                slotMinute={menu?.slot_minute}
              /></div>
              { this.state.annotation.requested_date ? (<MnInlineMessage mode="validation" messages={t(this.state.annotation.requested_date)} />) : null }
            </div> : null }
            {menu?.is_use_requested_worker ? (<div>
              <p>{t('Treatment.request_doctors')}</p>
              <div className="annotation">{this.context.formatSimple(t('Treatment.request_doctors_annotation'))}</div>
              <MnInputText
                name="requested_worker"
                value={ treatment.requested_worker }
                placeholder={t('Treatment.example_request_doctors')}
                onChange={ this.onChangeTreatment }
                onValidate={ this.onValidate }
                validates={ TreatmentValidators.requested_worker_i18n }
                t={this.context.t}
              />
            </div>) : null }
            {menu?.accept_stripe_payment === 'acceptable' ? (<div id="credit_card">
              <p>{t('Treatment.credit_card')}<span className="required">{t('Treatment.required')}</span></p>
              <Elements stripe={stripePromise} options={{ locale: this.context.i18n.language }}>
                <CardSetupForm
                  clientSecret={this.state.treatment.client_secret}
                  clientSecretResetPath={UserApiV1StripeClientSecretResetPath()}
                  isRegister={this.state.isCardRegistered}
                  onRegister={this.onRegisterCard}
                  onUnregister={this.onUnregisterCard}
                  onToast={this.context.onHeaderToast}
                  errorMessage={this.state.annotation.credit_card?.length > 0 ? this.state.annotation.credit_card[0] : undefined}
                  t={this.context.t}
                />
              </Elements>
            </div>) : null}
            {menu?.is_use_checklists && checklists.some(checklist => checklist.subject.trim() !== '') ? (<>
              <div>
                <p>{t('Treatment.checklists')}</p>
                <div className="mt-md annotation">{t('Treatment.checklists_annotation')}</div>
              </div>
              {checklists.map((checklist, index) => {
                if (checklist.subject.trim() === '') { return; }
                return (
                  <div className="mt-lg" key={index}>
                    <p className="nest">{checklist.subject}<span className="required">{t('Treatment.required')}</span></p>
                    <MnInputCheckboxGroup
                      name={`checklist${index}`}
                      groups={[{ key: '1', value: t('Treatment.iagree') }]}
                      class="ml-sm"
                      btnClass="c-mn-checkbox-btn c-mn-checkbox-btn--no-border"
                      errors={ this.state.annotation?.checklists && this.state.annotation?.checklists[index] }
                      onValidate={ this.onValidate }
                      required={ requiredMessage }
                      t={this.context.t}
                    />
                  </div>
                );
              })}
            </>) : null }
          </div>
          { isRegionalMedicalCooperation
            ? <PatientHealthConditionForm
              onChange={ this.onChangePatientHealthCondition }
              annotation={ this.state.annotation }
              patientHealthCondition={ patientHealthCondition }
              onValidate={ this.onValidate }
              requiredMessage={ requiredMessage }
            /> : null }
          <div className="p-interview--annotation">
            <span><a target="_blank" rel="noreferrer" href="https://medicalnote.co.jp/privacy">{t('Treatment.privacy_policy')}</a>・{this.renderTermsLink()}</span>
          </div>
          <div className="p-interview--submit">
            <MnButton class="c-mn-btn--first" onClick={this.onSave}><span>{t('Treatment.agree_and_apply')}</span></MnButton>
          </div>
        </div>
      </div>
    );
  }
}
